<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm">
      <el-form-item label="机构名称">
        <el-input
          v-model="dataForm.name"
          placeholder="机构名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="rgetDataList()">查询</el-button>
        <el-button
          v-if="isAuth('sys:org:save')"
          type="primary"
          @click="addOrUpdateHandle()"
          >新增</el-button
        >
        <el-button type="info" @click="excel" v-if="isAuth('sys:org:export')" >
          导出<i class="el-icon-download"></i>
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%"
    >
      <el-table-column
        prop="orgCode"
        header-align="center"
        align="center"
        label="机构编码"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="teacherNum"
        header-align="center"
        align="center"
        label="教师数量"
      >
      </el-table-column>
      <el-table-column
        prop="studentNum"
        header-align="center"
        align="center"
        label="学生数量"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        header-align="center"
        align="center"
        label="联系电话"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        header-align="center"
        align="center"
        label="地址"
      >
      </el-table-column>
      <el-table-column
        prop="description"
        header-align="center"
        show-overflow-tooltip
        align="center"
        label="简介"
      >
      </el-table-column>
      <el-table-column
              prop="createTime"
              header-align="center"
              align="center"
              width="160"
              label="创建时间"
      >
      </el-table-column>
      <el-table-column
              prop="updateTime"
              header-align="center"
              align="center"
              width="160"
              label="修改时间"
      >
      </el-table-column>
      <el-table-column

        header-align="center"
        align="center"
        width="180"
        label="操作"
      >
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="addOrUpdateHandle(row.id)"
            >修改</el-button
          >
          <el-button type="text" size="small" @click="deleteHandle(row)" style="color:#F56E6E"
            >删除</el-button
          >
          <el-button
            v-if="orgId !== row.id"
            type="text"
            size="small"
            @click="getCourseTree(row)"
          >
            课程权限
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 分配课程权限 -->
    <el-dialog
      :visible.sync="authVisible"
      destroy-on-close
      title="分配课程权限"
      :close-on-click-modal="false"
    >
      <el-tree
        ref="courseTree"
        :data="treeData"
        :props="treeProps"
        node-key="id"
        show-checkbox
        :expand-on-click-node="false"
      ></el-tree>
      <footer slot="footer">
        <el-button @click="authClose">取消</el-button>
        <el-button type="primary" @click="authSubmit()" :loading="loading"
          >确定</el-button
        >
      </footer>
    </el-dialog>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./org-add-or-update";
import {getLoginToken} from "../../../utils";

export default {
  data() {
    return {
      dataForm: {
        name: "",
      },
      treeProps: {
        label: "name",
        children: "children",
      },
      currentId: "",
      treeData: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      defaultCheckedKeys: [],
      totalPage: 0,
      authVisible: false,
      dataListLoading: false,
      loading: false,
      addOrUpdateVisible: false,
      nowLoginOrgId: ''
    };
  },
  components: {
    AddOrUpdate,
  },
  computed: {
    orgId() {
      return this.$store.state.user.orgId;
    },
  },
  created() {
    this.getDataList();
    this.getLoginOrgId();
  },
  methods: {
    authClose() {
      this.authVisible = false;
    },
    getLoginOrgId() {
      let orgId =  JSON.parse(this.$cookie.get("loginUser")).orgId;
      this.nowLoginOrgId = orgId;
    },
    manageOrgIdFlag() {
      return this.nowLoginOrgId === '2cee6ec71ed84a979f36db6529bc1328';
    },
    getCourseTree(row) {
      this.currentId = row.orgId;
      this.$http({
        url: this.$http.adornUrl("course/user/coursePower/tree"),
        method: "get",
        params: this.$http.adornParams({
          inviterId: row.orgId,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.treeData = data.data;
          // 先清空 defaultCheckedKeys
          this.defaultCheckedKeys = [];
          // 递归拿到选中的节点
          this.getCheckedNodes(data.data);
          this.authVisible = true;
          this.$nextTick(() => {
            this.$refs.courseTree.setCheckedKeys(this.defaultCheckedKeys);
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    authSubmit() {
      const courseIds = this.$refs.courseTree
        .getCheckedNodes(true)
        .map((i) => i.id);
      this.loading = true;
      this.$http({
        url: this.$http.adornUrl("course/user/save"),
        method: "post",
        data: {
          courseIds,
          userId: this.currentId,
        },
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success("课程权限分配成功！");
            this.authVisible = false;
          } else {
            this.$message.error(data.msg);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCheckedNodes(data) {
      data.forEach((i) => {
        if (i.choseFlag) {
          this.defaultCheckedKeys.push(i.id);
        } else {
          if (i.children) {
            this.getCheckedNodes(i.children);
          }
        }
      });
    },
     rgetDataList(){
      this.pageIndex = 1;
      this.getDataList()
    },
    excel(){
      let url = this.$http.adornUrl("/sys/org/excel")
      let param = "?token=" + getLoginToken()
      param += "&name=" + this.dataForm.name
      url =  url + param;
      window.location.href = url;
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("sys/org/list"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          ...this.dataForm,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(row) {
      const { orgId, name } = row;
      this.$confirm(`确认删除${name}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("sys/org/delete"),
          method: "delete",
          data: orgId,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getDataList();
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
  },
};
</script>
